import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { educationResource, fetchRecentActivities } from '../../utilities/dashboardServices'
import { toast } from 'react-toastify'

export const fetchEducationResource = createAsyncThunk(
    'users/fetchEducationResource', educationResource
)

const initialState = {
    educationResource:{
        loader:false,
        allCategoryObj:{},
        post:[],
        postCount:'',
        featuredPost:{}
    }
}

const educationResourceDirectorySlice = createSlice({
    name: 'recentActivities',
    initialState,
    reducers: {
        educationResourceReset: (state) => {
            // toast.success("RecentActivities reseted Successfully")
            state.value = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEducationResource.pending, (state, action) => {
                // toast.warn("RecentActivities pending")
                state.educationResource.loader=true
            })
            .addCase(fetchEducationResource.fulfilled, (state, action) => {
                let data=action.payload
                const CATEGORY = Object.keys(data.category).map(key => ({
                    ID: parseInt(key),
                    name: data.category[key]
                }));
                const EDUCATIONALTOPICS = Object.keys(data.topic).map(key => ({
                    ID: parseInt(key),
                    name: data.topic[key]
                }));
                const CONTENTTYPE = Object.keys(data.contenttype).map(key => ({
                    ID: parseInt(key),
                    name: data.contenttype[key]
                }));
                const LANGUAGE = Object.keys(data.language).map(key => ({
                    ID: parseInt(key),
                    name: data.language[key]
                }));
                CATEGORY.sort((a, b) => {
                    if (a.name === null) return 1; // If a.name is null, place it at the end
                    if (b.name === null) return -1; // If b.name is null, place it at the end
                    return a.name.localeCompare(b.name);
                });
                EDUCATIONALTOPICS.sort((a, b) => {
                    if (a.name === null) return 1; // If a.name is null, place it at the end
                    if (b.name === null) return -1; // If b.name is null, place it at the end
                    return a.name.localeCompare(b.name);
                });
                CONTENTTYPE.sort((a, b) => {
                    if (a.name === null) return 1; // If a.name is null, place it at the end
                    if (b.name === null) return -1; // If b.name is null, place it at the end
                    return a.name.localeCompare(b.name);
                });
                LANGUAGE.sort((a, b) => {
                    if (a.name === null) return 1; // If a.name is null, place it at the end
                    if (b.name === null) return -1; // If b.name is null, place it at the end
                    return a.name.localeCompare(b.name);
                });
                
                  let obj ={
                    "CATEGORY":CATEGORY,
                    "EDUCATIONAL TOPICS": EDUCATIONALTOPICS,
                    "CONTENT TYPE": CONTENTTYPE,
                    "LANGUAGE":LANGUAGE,
                  }
                  let filter={}

                  let obj1=Object.keys(obj).map((key)=>{
                    filter[key] = obj[key].map((item) => ({
                        ...item,
                        isChecked:false, // Toggle isChecked
                      }));
                    })
                 state.educationResource.allCategoryObj =filter
                 state.educationResource.post=data.post
                 state.educationResource.featuredPost=data.featuredPost
                 state.educationResource.postCount=data.postCount
                 state.educationResource.loader=false

            })
            .addCase(fetchEducationResource.rejected, (state, action) => {
                state.educationResource.loader=false
                toast.error(action.error.message)
            })
    },
})

export const { educationResourceReset } = educationResourceDirectorySlice.actions
export default educationResourceDirectorySlice.reducer